import React from 'react';
import { Line } from '@ant-design/plots';
import { Props } from './types';

const DemoLine: React.FC<Props> = ({ data }) => {
  const config = {
    data: data?.length > 0 && data,
    xField: 'time',
    yField: 'value',

    xAxis: {
      label: {
        style: {
          fill: 'none',
          fillOpacity: 0,
        },
      },

      line: {
        style: {
          stroke: 'transparent',
          lineWidth: 0,
          strockOpacity: 0,
        },
      },

      grid: {
        line: {
          style: {
            stroke: 'transparent',
            lineWidth: 0,
          },
        },
      },

      tickLine: {
        style: {
          stroke: 'transparent',
          lineWidth: 0,
        },
      },
    },

    yAxis: {
      label: {
        style: {
          fill: 'transparent',
        },
      },
      grid: {
        line: {
          style: {
            stroke: 'transparent',
            lineWidth: 0,
          },
        },
      },
    },

    label: {
      style: {
        fill: 'transparent',
        labelOpacity: 0,
      },
      rotate: 0,
      offsetX: 10,
      offsetY: 5,
    },

    point: {
      size: 2,
      shape: 'circle',
      style: {
        fill: '#5B8FF9',
        stroke: '#5B8FF9',
        lineWidth: 1,
      },
    },

    tooltip: {
      formatter: (datum: any) => {
        return {
          name: `Atendimentos`,
          value: `<span style="font-size: 18px">${datum.value} </span>`,
        };
      },
    },

    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: '#000',
          fill: '#000',
        },
      },
    },

    interactions: [
      {
        type: 'marker-active',
      },
    ],
  };
  return <Line {...config} />;
};

export default DemoLine;
